import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/credentials/Login.vue'
import PaxConnect from '@/components/module/pc/PaxConnect.vue'
import PaxConnectOC from '@/components/module/pc/PaxConnectOC.vue'

import OfficeClient from '@/components/module/officeclient/OfficeClient.vue'
import OfficeClientGiata from '@/components/module/officeclient/OfficeClientGiata.vue'

import Logout from '@/components/credentials/Logout.vue'
import Dashboard from '@/components/Dashboard.vue'
import Medien from '@/components/module/Medien.vue'
import Benutzer from '@/components/module/Benutzer.vue'
import BenutzerRollen from '@/components/module/BenutzerRollen.vue'
import Templates from '@/components/module/Templates.vue'
import TemplateDefault from '@/components/module/templates/TemplateDefault.vue'
import CounterMain from '@/views/counter/main.vue'

import Rechte from '@/components/module/Rechte.vue'
import Mails from '@/components/module/Mails.vue'
import MailsDefault from '@/components/module/mails/MailDefault.vue'
import RechteEditor from '@/components/module/Rights/RightDefault.vue'
import RollenDefault from '@/components/module/roles/RolesDefault'
import BenutzerDefault from '@/components/module/users/UserDefault'
import Firmen from '@/components/module/Firmen.vue'
import CompanyDefault from '@/components/module/company/CompanyDefault'
import StandortDefault from '@/components/module/company/StandortDefault'
import DashboardMain from '@/components/module/dashboard/DashboardMain'
import MainLocation from '@/components/module/dashboard/MyLocation'
import MainDevices from '@/components/module/dashboard/MyDevices'
import DeviceDefault from '@/components/module/device/DeviceDefault'
import AppsDefault from '@/components/module/apps/AppsDefault'
import PreviewDevice from '@/components/module/device/Preview'
import PlaylistDefault from '@/components/module/playlist/PlaylistDefault'
import Geraete from '@/components/module/Geraete.vue'
import Support from '@/components/module/Support.vue'
import Geraetegruppen from '@/components/module/Geraetegruppen.vue'
import Apps from '@/components/module/Apps.vue'
import Playlist from '@/components/module/Playlist.vue'
import Channels from '@/components/module/Channels.vue'
import PlaylistItem from '@/components/module/playlistItem/PlaylistItemDefault.vue'
import unbekannteGeraete from '@/components/module/unbekannteGeraete.vue'
import Uploads from '@/components/module/Uploads.vue'
import Veroeffentlichungen from '@/components/module/Veroeffentlichungen.vue'
import Mediatheke from "@/components/module/Mediatheke.vue";

Vue.use(Router)

export default new Router({
    hashbang: true,
    history: true,
    linkActiveClass: 'active-class',
    scrollBehavior() {
        return {x: 0, y: 0}
    },
    routes: [
        {
            path: '/',
            component: Login
        },
        {
            path: '/login',
            component: Login
        },
        {
            path: '/Logout',
            name: 'Logout',
            component: Logout
        },
        {
            path: '/pc/addImage',
            name: 'PaxConnect',
            component: PaxConnect
        },
        {
            path: '/oc/url',
            name: 'PaxConnectoc',
            component: PaxConnectOC
        },
        {
            path: '/bs/addImage',
            name: 'BosisConnect',
            component: PaxConnect
        },
        {
            path: '/oc/index',
            name: 'OfficeClient',
            component: OfficeClient
        },
        {
            path: '/ga/index',
            name: 'OfficeClientII',
            component: OfficeClientGiata
        },
        {
            path: '/ga/index/:giataId',
            name: 'OfficeClientIV',
            component: OfficeClientGiata
        },
        {
            path: '/ga/index/:giataId/:provider',
            name: 'OfficeClientIII',
            component: OfficeClientGiata
        },
        {
            path: '/preview/:guidDevice',
            name: 'preview',
            component: PreviewDevice
        },
        {
            path: '/counter/show/:guid',
            name: 'CounterMain',
            component: CounterMain
        },
        {
            path: '/Dashboard',
            name: 'Dashboard',
            component: Dashboard,
            children: [
                {
                    path: 'Medien',
                    name: 'Medien',
                    component: Medien,
                }, {
                    path: 'Mediathek',
                    name: 'Mediathek',
                    component: Mediatheke,
                },
                {
                    path: 'Benutzer',
                    name: 'Benutzer',
                    component: Benutzer,
                },
                {
                    path: 'Main',
                    name: 'DashboardMain',
                    component: DashboardMain,
                },
                {
                    path: 'MainLocation',
                    name: 'MainLocation',
                    component: MainLocation,
                },
                {
                    path: 'MainDevices',
                    name: 'MainDevices',
                    component: MainDevices,
                },
                {
                    path: 'Rollen',
                    name: 'BenutzerRollen',
                    component: BenutzerRollen,
                },
                {
                    path: 'Templates',
                    name: 'Templates',
                    component: Templates,
                },
                {
                    path: 'Mails',
                    name: 'Mails',
                    component: Mails,
                },
                {
                    path: '/admin/mails/:guid',
                    name: 'MailsDefault',
                    component: MailsDefault,
                },
                {
                    path: 'Rechte',
                    name: 'Rechte',
                    component: Rechte,
                },
                {
                    path: '/Rechte/:guid',
                    name: 'RechteEditor',
                    component: RechteEditor,
                },
                {
                    path: '/Rollen/:guid',
                    name: 'RollenDefault',
                    component: RollenDefault
                },
                {
                    path: '/Templates/:guid',
                    name: 'TemplateDefault',
                    component: TemplateDefault
                },
                {
                    path: '/Netzwerke/:companyId/Rollen/:guid',
                    name: 'RollenDefaultNetzwerk',
                    component: RollenDefault
                },
                {
                    path: '/Benutzer/:guid',
                    name: 'BenutzerDefault',
                    component: BenutzerDefault
                },
                {
                    path: '/Netzwerke/:companyId/Benutzer/:guid',
                    name: 'BenutzerDefaultNetzwerk',
                    component: BenutzerDefault
                },
                {
                    path: 'Netzwerke',
                    name: 'Firmen',
                    component: Firmen
                },
                {
                    path: 'Support',
                    name: 'Support',
                    component: Support,
                },
                {
                    path: 'Geraete',
                    name: 'Geraete',
                    component: Geraete,
                },
                {
                    path: 'Geraetegruppen',
                    name: 'Geraetegruppen',
                    component: Geraetegruppen,
                },
                {
                    path: 'Apps',
                    name: 'Apps',
                    component: Apps,
                },
                {
                    path: 'Playlist',
                    name: 'Playlist',
                    component: Playlist,
                },
                {
                    path: 'Channels',
                    name: 'Channels',
                    component: Channels,
                },
                {
                    path: 'unbekannteGeraete',
                    name: 'unbekannteGeraete',
                    component: unbekannteGeraete,
                },
                {
                    path: 'Uploads',
                    name: 'Uploads',
                    component: Uploads,
                },
                {
                    path: 'Veroeffentlichungen',
                    name: 'Veroeffentlichungen',
                    component: Veroeffentlichungen,
                },
                {
                    path: '/Netzwerke/:companyId',
                    name: 'CompanyDefault',
                    component: CompanyDefault
                },
                {
                    path: '/Netzwerke/:companyId/:tabId',
                    name: 'CompanyDefault',
                    component: CompanyDefault
                },
                {
                    path: '/Netzwerke/:companyId/Geraete/:deviceGuid',
                    name: 'DeviceDefault',
                    component: DeviceDefault
                },
                {
                    path: '/Netzwerke/:companyId/Playlist/:guid',
                    name: 'PlaylistDefault2',
                    component: PlaylistDefault
                },
                {
                    path: '/Netzwerke/:companyId/Standort/:locationId',
                    name: 'Standort2',
                    component: StandortDefault
                },
                {
                    path: '/Netzwerke/:companyId/Standort/:locationId/Benutzer/:guid',
                    name: 'BenutzerDefaultLocation',
                    component: BenutzerDefault
                },
                {
                    path: '/Geraete/:deviceGuid',
                    name: 'DeviceDefault1',
                    component: DeviceDefault
                },
                {
                    path: '/Playlist/:guid',
                    name: 'PlaylistDefault1',
                    component: PlaylistDefault
                },
                {
                    path: '/PlaylistItem/:guid',
                    name: 'PlaylistItem',
                    component: PlaylistItem
                },
                {
                    path: '/Apps/:guid',
                    name: 'AppsDefault',
                    component: AppsDefault
                }
            ]
        }
    ]
})
